import React, { Component } from "react";

import { withRouter } from "react-router-dom";

import { AppContext } from "../../App";
import Loader from "../../components-utils/Loader";
import I18n from "../../components-utils/I18n";
import { validateObject, mandatory } from "../../services/validator";

import { getPrice, savePrice } from "../../services/api";
import { loadItem } from "../../services/utils";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import "./Price.css";

const emptyI18n = {
  label: "",
  description: ""
};
const emptyPrice = (merchantCode, langs) => ({
  id: -1,
  technicalLabel: "",
  i18n: langs.reduce((acc, lang) => ({ ...acc, [lang.code]: emptyI18n }), {}),
  default: false
});

class Price extends Component {
  state = {
    lang: "fr",
    errors: {}
  };

  async componentDidMount() {
    const result = await loadItem(this.props, getPrice, emptyPrice);
    if (result !== undefined) {
      this.setState({
        price: result.item,
        merchantCode: result.merchantCode
      });
    }
  }

  changeLang = lang => {
    this.setState({ lang });
  };
  changeFields = name => e => {
    const value = e.target.value;
    this.setState(state => ({
      price: {
        ...state.price,
        technicalLabel:
          state.lang === "fr" && name === "label"
            ? value
            : state.price.technicalLabel,
        i18n: {
          ...state.price.i18n,
          [state.lang]: {
            ...state.price.i18n[state.lang],
            [name]: value
          }
        }
      }
    }));
  };

  labelValidators = this.props.langs.reduce(
    (acc, lang) => ({ ...acc, [lang.code]: { label: [mandatory] } }),
    {}
  );

  savePrice = () => {
    const {
      price: { i18n }
    } = this.state;

    const errors = validateObject(i18n, this.labelValidators);

    this.setState({ errors }, () => {
      const { errors, price, merchantCode } = this.state;
      if (errors === undefined) {
        const {
          snackbar,
          history,
          match: {
            params: { id }
          }
        } = this.props;
        if (merchantCode !== undefined) {
          savePrice(id, merchantCode, price)
            .then(price => {
              this.setState({ price }, () => {
                history.push(`/price-grid/${price.id}`);
                snackbar("Informations enregistrées");
              });
            })
            .catch(e => {
              console.log(e);
              snackbar(
                "Erreur pendant la sauvegarde du prix. Veuillez réessayer",
                "error"
              );
            });
        }
      }
    });
  };

  renderLoader() {
    return <Loader loading={true} />;
  }

  render() {
    const { price, lang, errors } = this.state;
    return price !== undefined ? (
      <Card key="page">
        <CardContent>
          <Typography variant="h4">
            {price.technicalLabel !== ""
              ? price.technicalLabel
              : "Nouveau prix"}
          </Typography>
          <I18n
            langs={this.props.langs}
            lang={lang}
            changeFields={this.changeFields}
            changeLang={this.changeLang}
            elements={price.i18n}
            emptyElement={emptyI18n}
            errors={errors}
          />
        </CardContent>
        <CardActions className="sp-price--actions">
          <Button
            variant="contained"
            color="secondary"
            onClick={this.savePrice}
          >
            Valider
          </Button>
        </CardActions>
      </Card>
    ) : (
      this.renderLoader()
    );
  }
}

const enhanced = WrappedComponent => props => {
  return (
    <AppContext.Consumer>
      {app => {
        return (
          <WrappedComponent
            {...props}
            snackbar={app.snackbar.open}
            langs={app.langs}
          />
        );
      }}
    </AppContext.Consumer>
  );
};

export default withRouter(enhanced(Price));



// WEBPACK FOOTER //
// ./src/components/grid/Price.js